'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackgroundImage = undefined;

var _components = require('@rebass/components');

var _components2 = _interopRequireDefault(_components);

var _styledSystem = require('styled-system');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var bgImage = (0, _styledSystem.style)({
  prop: 'image',
  alias: 'src',
  cssProperty: 'backgroundImage',
  getter: function getter(n) {
    return 'url(' + n + ')';
  }
});
var BackgroundImage = exports.BackgroundImage = (0, _components2.default)({
  width: 1,
  ratio: 3 / 4,
  backgroundSize: 'cover',
  backgroundPosition: 'center'
}, bgImage, 'width', 'ratio', 'backgroundSize', 'backgroundPosition', 'space', 'color');
BackgroundImage.displayName = 'BackgroundImage';
exports.default = BackgroundImage;